import React from "react"
import { cn } from "../../utils/cn"

/** Wrapper com scroll horizontal + <table> base. Use no layout desktop. */
export const Table: React.FC<React.HTMLAttributes<HTMLTableElement>> = ({
    className,
    children,
    ...props
}) => (
    <div className="w-full overflow-x-auto">
        <table className={cn("w-full text-left text-sm", className)} {...props}>
            {children}
        </table>
    </div>
)

export const THead: React.FC<React.HTMLAttributes<HTMLTableSectionElement>> = ({
    className,
    children,
    ...props
}) => (
    <thead
        className={cn("border-b border-border bg-elevated/40", className)}
        {...props}
    >
        {children}
    </thead>
)

export const TBody: React.FC<React.HTMLAttributes<HTMLTableSectionElement>> = ({
    className,
    children,
    ...props
}) => (
    <tbody className={cn("divide-y divide-border", className)} {...props}>
        {children}
    </tbody>
)

export const Tr: React.FC<React.HTMLAttributes<HTMLTableRowElement>> = ({
    className,
    children,
    ...props
}) => (
    <tr
        className={cn("transition-colors hover:bg-elevated/40", className)}
        {...props}
    >
        {children}
    </tr>
)

interface ThProps extends React.ThHTMLAttributes<HTMLTableCellElement> {
    sortable?: boolean
    indicator?: React.ReactNode
}

export const Th: React.FC<ThProps> = ({
    className,
    sortable,
    indicator,
    children,
    ...props
}) => (
    <th
        className={cn(
            "px-4 py-3 text-xs font-semibold uppercase tracking-wider text-muted",
            sortable && "cursor-pointer select-none hover:text-text",
            className
        )}
        {...props}
    >
        <span className="inline-flex items-center gap-1">
            {children}
            {indicator}
        </span>
    </th>
)

export const Td: React.FC<React.TdHTMLAttributes<HTMLTableCellElement>> = ({
    className,
    children,
    ...props
}) => (
    <td className={cn("px-4 py-3.5 text-sm text-text", className)} {...props}>
        {children}
    </td>
)
